import "../../index46.css";
import { jsx as o, jsxs as m } from "react/jsx-runtime";
import { InformationLineIcon as _ } from "@ifrc-go/icons";
import { _ as i } from "../../cs-piwRuCFZ.js";
import "../../type-BFTbooL7.js";
import u from "../Container/index.js";
import f from "../DropdownMenu/index.js";
const h = "_info-popup_i3rna_1", w = "_label_i3rna_2", C = "_icon_i3rna_7", N = "_dropdown-container_i3rna_15", b = "_content_i3rna_20", n = {
  infoPopup: h,
  label: w,
  icon: C,
  dropdownContainer: N,
  content: b
};
function D(r) {
  const {
    className: a,
    icon: t = /* @__PURE__ */ o(_, {}),
    infoLabel: e,
    title: c,
    description: p,
    withoutIcon: s,
    popupClassName: l,
    descriptionClassName: d
  } = r;
  return /* @__PURE__ */ o(
    f,
    {
      label: /* @__PURE__ */ m("div", { className: n.label, children: [
        e,
        !s && t && /* @__PURE__ */ o("div", { className: n.icon, children: t })
      ] }),
      popupClassName: i(n.dropdownContainer, l),
      className: i(n.infoPopup, a),
      variant: "tertiary",
      withoutDropdownIcon: !0,
      children: /* @__PURE__ */ o(
        u,
        {
          heading: c,
          childrenContainerClassName: i(d, n.content),
          withInternalPadding: !0,
          children: p
        }
      )
    }
  );
}
export {
  D as default
};
